import { ReactComponent as Wordmark } from 'assets/wordmark.svg';
import { AccountButton, ChainButton, Button } from 'components/Button';
import { useChain, useSettings } from 'contexts';
import React from 'react';
import { SunIcon as LightModeIcon, MoonIcon as DarkModeIcon } from '@heroicons/react/outline';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import MenuButton from './MenuButton';

const Header = () => {
  const { t } = useTranslation();
  const { styleSlug, account, connect, disconnect } = useChain();
  const { toggleSidebar, isDarkMode, toggleDarkMode } = useSettings();

  return (
    <div className="bg-white dark:bg-gray-111">
      <div className="relative flex items-center justify-between px-4 py-3 md:py-4">
        <div className="flex items-center">
          <MenuButton
            className={`-mt-2 ml-0 md:ml-1`}
            styleSlug={styleSlug}
            onClick={toggleSidebar}
          />
          <Link to="/" className="block w-16 ml-2 md:ml-6">
            <Wordmark
              className={`text-${styleSlug}-primary dark:text-${styleSlug}-light dark:drop-shadow-${styleSlug} fill-current`}
              title="SURF"
            />
          </Link>
          <span
            className={`font-varela-round tracking-widest text-2xl text-gray-444 dark:text-white uppercase ml-4 pl-3 hidden md:inline border-l-2 border-${styleSlug}-light`}
          >
            {t('header.dashboard')}
          </span>
        </div>
        <div className="flex items-center text-right space-x-1 md:space-x-2">
          <Button onClick={toggleDarkMode} padded={false}>
            {isDarkMode ? (
              <LightModeIcon className="w-5 h-5 mx-auto" />
            ) : (
              <DarkModeIcon className="w-5 h-5 mx-auto" />
            )}
          </Button>
          <ChainButton />
          {account ? (
            <AccountButton account={account} onClick={disconnect} />
          ) : (
            <Button onClick={connect}>{t('header.connect')}</Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
